import React, { useContext, useEffect, useState } from 'react';
import { Typography, Button, Dropdown, Menu } from 'antd';
import { Row, Col } from 'react-flexbox-grid';
import SearchContext from '../../context';
import { useTheme } from "../../ThemeContext.js";
import menu from '../../assets/bg/hamburger.svg';
import close_menu from '../../assets/bg/close.svg';
import language from '../../assets/bg/language.svg';
import { withRouter } from 'react-router';
import LangContext from '../../context/LangContext';

const Navigation = (props) => {

    const { Title } = Typography;

    const themeState = useTheme(); 

    const contextService = useContext(SearchContext);

    const { switchLang, lang, currentLangData } = useContext(LangContext);

    const [isDrawer, setDrawer] = useState(false);

    useEffect(() => {
        if(contextService.width >= 991){
            setDrawer(false);
        }
    }, [contextService.width])

    const handleNav = () => {
        window.scrollTo(0,0);
        props.history.push({
            pathname: '/'
        });
    }

    const menuNav = (
        <Menu>
          <Menu.Item style={{ backgroundColor: lang === 'es-ES' ? '#0062ff' : null, padding: '1em 1.75em' }} onClick={() => switchLang('es-ES')} >
            <span className="no-margin montserrat" style={{ cursor: 'pointer', fontSize: '1.15rem', color: lang === 'es-ES' ? '#fff' : null }}>Español</span>
          </Menu.Item>
          <Menu.Item style={{ backgroundColor: lang === 'en-US' ? '#0062ff' : null, padding: '1em 1.75em' }} onClick={() => switchLang('en-US')}>
            <span className="no-margin montserrat" style={{ cursor: 'pointer', fontSize: '1.15rem', color: lang === 'en-US' ? '#fff' : null }}>English</span>
          </Menu.Item>
        </Menu>
      );

    const renderCTA = () => {
        return(
            <Button style={{ marginLeft: '1.65em' }} type="primary" shape="round" size="large" className="main-cta" onClick={() => themeState.toggle()} >
                <span className="no-margin montserrat" style={{ fontSize: '1rem' }}>
                    {themeState.dark === false ? 'Dark' : 'Light'}
                </span>  
            </Button>
        )
    }

    const renderMenuIcon = () => {
        return(
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <Dropdown overlay={menuNav} placement="bottomRight">
                    <div className="ant-dropdown-link" style={{ marginLeft: '1.65em', cursor: 'pointer' }} onClick={e => e.preventDefault()}>
                        <img src={language} alt={language} style={{ width: '2rem' }} />
                    </div>
                </Dropdown>
                <div onClick={() => {setDrawer(!isDrawer);}}  style={{ marginLeft: '.65em', cursor: 'pointer' }} >
                    <img src={isDrawer === false ? menu : close_menu} alt={isDrawer === false ? menu : close_menu} style={{ width: 45 }} />
                </div>
            </div>
        )
    }

    const renderMenu = () => {
        return(
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexDirection: 'row' }}>
                <a href="#proyectos" style={{ textDecoration: 'none' }}>
                    <span className="no-margin montserrat main-title-color" style={{ cursor: 'pointer', fontSize: '1.15rem' }}>{currentLangData.NAVIGATION.proyectos}</span>
                </a>
                
                <div style={{ marginLeft: '1.65em' }} >
                    <a href="#habilidades" style={{ textDecoration: 'none' }}>
                        <span className="no-margin montserrat main-title-color" style={{ cursor: 'pointer', fontSize: '1.15rem' }}>{currentLangData.NAVIGATION.habilidades}</span>
                    </a>
                </div>
                <div style={{ margin: '0 1.65em' }} >
                    <a href="#tools" style={{ textDecoration: 'none' }}>
                        <span className="no-margin montserrat main-title-color" style={{ cursor: 'pointer', fontSize: '1.15rem' }}>{currentLangData.NAVIGATION.herramientas}</span>
                    </a>
                </div>
                <a href="#contacto" style={{ textDecoration: 'none' }}>
                    <span className="no-margin montserrat main-title-color" style={{ cursor: 'pointer', fontSize: '1.15rem' }}>{currentLangData.NAVIGATION.contacto}</span>
                </a>
                <Dropdown overlay={menuNav} placement="bottomRight">
                    <div className="ant-dropdown-link" style={{ marginLeft: '1.65em', cursor: 'pointer' }} onClick={e => e.preventDefault()}>
                        <img src={language} alt={language} style={{ width: '2rem' }} />
                    </div>
                </Dropdown>
                {renderCTA()}
            </div>
        )
    }

    const renderMenuOff = () => {
        return(
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <a href="#proyectos" onClick={() => setDrawer(!isDrawer)} style={{ marginTop: -120, textDecoration: 'none', marginBottom: '2em'  }}>
                    <Title className="no-margin montserrat main-title-color" style={{ cursor: 'pointer', fontSize: '1.75rem' }}>{currentLangData.NAVIGATION.proyectos}</Title>
                </a>
                
                <div style={{ marginBottom: '2em' }} >
                    <a href="#habilidades" onClick={() => setDrawer(!isDrawer)} style={{ textDecoration: 'none' }}>
                        <Title className="no-margin montserrat main-title-color" style={{ cursor: 'pointer', fontSize: '1.75rem' }}>{currentLangData.NAVIGATION.habilidades}</Title>
                    </a>
                </div>
                <div style={{ marginBottom: '2em' }} >
                    <a href="#tools" onClick={() => setDrawer(!isDrawer)} style={{ textDecoration: 'none' }}>
                        <Title className="no-margin montserrat main-title-color" style={{ cursor: 'pointer', fontSize: '1.75rem' }}>{currentLangData.NAVIGATION.herramientas}</Title>
                    </a>
                </div>
                <a href="#contacto" onClick={() => setDrawer(!isDrawer)} style={{ marginBottom: '2.5em', textDecoration: 'none' }}>
                    <Title className="no-margin montserrat main-title-color" style={{ cursor: 'pointer', fontSize: '1.75rem' }}>{currentLangData.NAVIGATION.contacto}</Title>
                </a>            
                <Button type="primary" shape="round" size="large" className="main-cta" onClick={() => themeState.toggle()} style={{ marginBottom: '2.5em' }} >
                    <span className="no-margin montserrat" style={{ fontSize: '1rem' }}>
                        {themeState.dark === false ? 'Dark' : 'Light'}
                    </span>  
                </Button>
                <a href="mailto:rodd.sal23@gmail.com" style={{ textDecoration: 'none' }}>
                    <Button type="primary" shape="round" size="large" className="main-cta" style={{ height: 50 }} >
                        <span className="no-margin montserrat" style={{ fontSize: '1.15rem' }}>
                            {currentLangData.NAVIGATION.sendMessage}
                        </span>  
                    </Button>
                </a>
            </div>
        )
    }

    return(
        <div className="navbar base-padding">
            <div style={{ width: '100%', height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }} >
                <Row className="no-margin" style={{ width: '100%', height: 80  }} >
                    <Col className="no-padding" xs={8} sm={8} md={8} lg={4} style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }} >
                        <div onClick={() => handleNav()} style={{ cursor: 'pointer', width: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                            <svg className="accent-title-color" style={{ marginRight: '.75em' }} width="22" height="33" viewBox="0 0 22 33" xmlns="http://www.w3.org/2000/svg" class="mr-3"><path d="M2.828 29.203l2.52.97v-7.506l1.247.478 2.125.812v7.51l1.622.622c.422.162.89.162 1.312 0l1.34-.514v-7.618l.272-.105 3.107-1.183v7.611l2.56-.98a1.83 1.83 0 001.175-1.71v-6.34l.564-.23a1.83 1.83 0 001.177-1.69L22 4.924a1.83 1.83 0 00-1.161-1.71L13.358.332a1.834 1.834 0 00-2.492 1.706v1.997l6.641 2.545-.057 11.126-2.082.798-2.365.869V8.443a.914.914 0 00-1.262-.847l-.875.357-8.377-3.201A1.834 1.834 0 000 6.455v12.908a1.83 1.83 0 001.177 1.708l.474.183v6.24a1.83 1.83 0 001.177 1.71zm1.626-19.038l4.275 1.64v7.532L4.454 17.7v-7.535z" fill="currentColor" fillRule="nonzero"></path></svg>
                            <Title className="no-margin accent-title-color" style={{ fontSize: '1.25rem' }}>
                                Rodrigo Salmeron
                            </Title>
                        </div>
                    </Col>
                    <Col className="no-padding" xs={4} sm={4} md={4} lg={8} style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        {
                            contextService.width <= 991 ? renderMenuIcon() : renderMenu()
                        }
                    </Col>
                </Row>
            </div>
            {isDrawer === true ? 
            <div className="slideDown" style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} >
                {renderMenuOff()}
            </div> : null}
        </div>
    )
}

export default withRouter(Navigation);